import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component_SL_Text } from '../text/Component_SL_Text.js';
import { LL_V_L } from '@nu-art/thunderstorm-frontend';
import { generateArray } from '@nu-art/ts-common';
import './Component_SL_Paragraph.scss';
export const Component_SL_Paragraph = (p) => {
    return _jsxs(LL_V_L, { className: 'csl-paragraph', children: [...generateArray(p.rowCount, index => {
                if (index === p.rowCount - 1)
                    return _jsx(Component_SL_Text, { variant: p.variant, width: '65%' });
                return _jsx(Component_SL_Text, { variant: p.variant, width: '100%' });
            })] });
};
//# sourceMappingURL=Component_SL_Paragraph.js.map